import {Order} from './order';

export class OrderCreate {
    data: Order;

    constructor(data: Order) {
        this.data = data;
    }
}
